/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {Entity} from '../../core/main.entity';
import {BlockElementType} from '../enums';
import {HelperService} from '../../services/helper.service';

export class BlockElement extends Entity {
  type?: BlockElementType = 'basic';
}

export class BlockElementSettings extends Entity {
  getClasses?(ignoreKeys = []): string[] {
    const classes = [];

    for (const [key, value] of Object.entries(this)) {

      if (value && !ignoreKeys.includes(key)) {
        classes.push(`${HelperService.camelToDashCase(key)}-${HelperService.camelToDashCase(value)}`);
      }
    }

    return classes;
  }
}
